import { createTestIds } from '../../utils';

export const getTooltipTestIds = createTestIds('tooltip', [] as const);
